
import React, { Component, Fragment } from 'react';
import Header from './Header';
import _ from 'lodash';
import { TextField, Button, Snackbar, LinearProgress,
    Dialog, DialogContent, DialogActions, DialogTitle
} from '@material-ui/core';
import userdata from '../config/jwt_token'
import { browserHistory } from 'react-router'
import { uploadPaymentRequest } from '../utils/PaymentRequestApiUtils';
import Osms from '../images/vopr.png'

const SAMPLE_UPLOAD_FILE_TEMPLATE_URL = 'https://docs.google.com/spreadsheets/d/1SilngEENh7mBwYhQan-igfNeAQ6KC2R-D5ytxiWePK4/edit';
const tdStyle = {
  padding: '10px',
  alignItems: 'center',
  border: '1px solid black',
}

class InitializePR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      errorUsername: '',
      errorPassword: '',
      roleSelected: '',
      hideType: 'block',
      invalidLogin: false,
      isLogged: false,
      centralfinancefieldStyle: { width: '220px', textAlign: 'center' },
      cityfinancefieldStyle: { width: '220px', textAlign: 'center' },
      disablePaymentRequest: true,
      disableUploadPR: true,
      dialogOpen: false,
      selectedFile: null,
      selectedFileName: "",
      uploadDialogOpen: false,
      uploadDialogBoxText: "",
      inProgress: false,
      fileError: false,
      fileErrorText: "",
      snackMessage: "",
      snackOpen: false,
      validationsDialogOpen: false,
      validationErrors: [],
      csvValidationModalVisible: false,
      dbValidationModalVisible: false,
      faultyPRs:[],
    }
  }

  componentWillMount() {
    if (userdata) {
      let role = userdata.role
      let state = this.state
      //console.log(role)
      if (role === 'City Finance') {
        state.disableUploadPR = false
        state.disablePaymentRequest = false
      }
      if (role === 'root') {
        state.disableUploadPR = false
        state.disablePaymentRequest = false
      }
      this.setState({ ...state, loadOptions: true })
    }
    else {
      browserHistory.push('/')
      return
    }
  }
  
  handleClose() {
    this.setState({ dialogOpen: false })
  }

  handleUploadClose() {
    this.setState({ uploadDialogOpen: false })
  }

  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }

  handleValidationsDialogClose(){
    this.setState({ validationsDialogOpen: false })
  }

  handleNavigation(value) {
    switch (value) {
      case 'payment_request': {
        if (!this.state.disablePaymentRequest)
          browserHistory.push('/payment/request')
        else {
          this.setState({ dialogOpen: true })
        }
        return
      }
    }
  }

  uploadStatus = async () => {
    let selected_city = localStorage.getItem('selected_city');
    if((!selected_city) && userdata.city.length > 0) {
      selected_city = userdata.city[0].city_name;
      localStorage.setItem('selected_city', selected_city);
    }
    if(this.state.selectedFile !== null){
      this.setState({ uploadDialogOpen: false, uploadDialogBoxText: "", inProgress: true },()=>{
        let formData = new FormData()
        formData.append('upload', this.state.selectedFile)
        uploadPaymentRequest( formData, selected_city ).then(response => {
          if (response) {
            if (response.status) {
              setTimeout(()=>{
                  browserHistory.push({pathname:'/bulkPreview', state:{prObject:response.prObject, faultyPRs: response.faultyPRs}});
                  //window.location.reload();
              },500)
              
            }
            else if(response.invalidData){
              this.setState({ validationsDialogOpen: true, validationErrors: response.errors, inProgress: false })
            }
            else{
              if(response.message.includes("Consistency error")){
                this.setState({ dbValidationModalVisible : true, faultyPRs: response.faultyPRs })
              }
              else{
                this.setState({ csvValidationModalVisible : true, faultyPRs: response.faultyPRs })
              }
              
              this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
            }
          }
        })
      })
    }
    else{
      this.setState({ snackMessage: "Please select a file to upload.", snackOpen: true })
    }
  }

  handleFileChange = (event) => {
    let file = event.target.files[0];
    if(file.type === "text/csv" || file.type === "application/octet-stream" || file.type === "application/vnd.ms-excel"){
        this.setState({ selectedFile: file, selectedFileName: file.name })
        return
    }
    else{
        this.setState({ snackOpen: true, snackMessage: 'Only Csv files are allowed.' })
        return
    }
  }

  
  handleCSVModalCancel(){
    this.setState({csvValidationModalVisible:false});
  }

  handleDBModalCancel(){
    this.setState({dbValidationModalVisible:false});
  }
  ImageLoaded(){
    this.setState({ ImageLoaded: true })
  }

  render(){
    return(
      <Fragment>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-card zaps-form-card">
            <div className="zaps-init-hero">
              <img src={Osms} alt='logo' onLoad={this.ImageLoaded.bind(this)} />
              {this.state.ImageLoaded && (
                <h1>Zolo Accounting &amp; Payment System</h1>
              )}
              <p>Select an option below to create or bulk-upload payment requests.</p>
              <div className="zaps-init-actions">
                <Button size="large" variant="contained" color={this.state.disablePaymentRequest ? 'default' : 'primary'} disabled={this.state.disablePaymentRequest} onClick={this.handleNavigation.bind(this, 'payment_request')}>Create</Button>
                <Button size="large" variant="contained" color={this.state.disableUploadPR ? 'default' : 'primary'} disabled={this.state.disableUploadPR} onClick={()=>this.setState({ selectedFile: null, selectedFileName: "", uploadDialogOpen: true })}>Bulk Upload</Button>
              </div>
            </div>
          </div>
        <Dialog
          open={this.state.inProgress}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
              Loading...
              <br/><br/>
              <LinearProgress />
          </DialogContent>
        </Dialog>
        {/* FOR CSV VALIDATION*/}
        <Dialog
          open={this.state.csvValidationModalVisible}
          onClose={this.handleCSVModalCancel.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>
              There are errors in the file you are trying to upload.
          </DialogTitle>
          <DialogContent>
            <table className="zaps-dialog-table">
              <thead>
                <tr>
                  <th>Row Number</th>
                  <th>Column Name</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.faultyPRs && this.state.faultyPRs.map((error, i) => (
                    <tr key={i} className="zaps-row-error">
                      <td align="center">{error.row_number}</td>
                      <td align="center">{error.column_name}</td>
                      <td align="center">{error.reason}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </DialogContent>
          <DialogActions style={{justifyItems: 'center'}}>
          <Button onClick={this.handleCSVModalCancel.bind(this)} color="primary" autoFocus>
            Okay
          </Button>
        </DialogActions>
        </Dialog>
        {/* FOR DB VALIDATION*/}
        <Dialog
          open={this.state.dbValidationModalVisible}
          onClose={this.handleDBModalCancel.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>
              There are Consistency errors in the file you are trying to upload.
          </DialogTitle>
          <DialogContent>
            <table className="zaps-dialog-table">
              <thead>
                <tr>
                  <th>Vendor Name/Code</th>
                  <th>Payment Type</th>
                  <th>Invoice/PO Number</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.faultyPRs && this.state.faultyPRs.map((error, i) => (
                    <tr key={i} className="zaps-row-error">
                      <td align="center">{error.vendor_name} ({error.vendor_code})</td>
                      <td align="center">{error.type_of_payment}</td>
                      <td align="center">{error.unique_id}</td>
                      <td align="center">{error.reason}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </DialogContent>
          <DialogActions style={{justifyItems: 'center'}}>
          <Button onClick={this.handleDBModalCancel.bind(this)} color="primary" autoFocus>
            Okay
          </Button>
        </DialogActions>
        </Dialog>
        <Dialog
          title="You don't have access for this"
          actions={<Button
              label="OK"
              primary={true}
              onClick={this.handleClose.bind(this)}
            />}
          modal={true}
          contentStyle={{
            width: '100%',
            maxWidth: '800px',
            height: '200px'
          }}
          open={this.state.dialogOpen}
        >
          Please contact product@zolostays.com
        </Dialog>
        <Dialog
          open={this.state.validationsDialogOpen}
          onClose={this.handleValidationsDialogClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        />
        <Dialog
          open={this.state.uploadDialogOpen}
          onClose={this.handleUploadClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
              <TextField
                label="Upload CSV"
                value={this.state.selectedFileName}
                disabled={true}
                margin='normal'
                InputLabelProps={{ shrink: true }}
                style={{ width: '250px' }}
                error={this.state.fileError}
                helperText={this.state.fileErrorText}
              />
              <label htmlFor={'file-upload'} className='zaps-browse-btn'>
                Browse
              </label>
              <input id={'file-upload'} type="file" onClick={(event) => event.target.value = null} onChange={this.handleFileChange.bind(this)} style={{ display: "none" }} accept="text/csv, application/octet-stream, application/vnd.ms-excel" />
            </div>
          </DialogContent>
          <DialogActions style={{justifyItems: 'right'}}>
            <Button variant="contained" href={SAMPLE_UPLOAD_FILE_TEMPLATE_URL} size="small" target="_blank" color="primary">
              Download Template
            </Button>
            <Button onClick={this.handleUploadClose.bind(this)} color="secondary" variant="contained">
              Cancel
            </Button>
            <Button onClick={this.uploadStatus.bind(this)} color="primary" autoFocus variant="contained">
              Upload
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={2500}
          onClose={this.handleCloseSnack.bind(this)}
        />
        </div>{/* end zaps-page-wrap */}
      </Fragment>
    )
  }
}

export default InitializePR;



// WEBPACK FOOTER //
// ./src/components/InitializePR.js